"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var normalizeContentColor_1 = require("../darkMode/normalizeContentColor");
// TODO: Rename to DarkmodePlugin in next major release
/**
 * Copy plugin, hijacks copy events to normalize the content to the clipboard.
 */
var CopyPlugin = /** @class */ (function () {
    function CopyPlugin() {
        var _this = this;
        this.onExtract = function (isCut) { return function (event) {
            // if it's dark mode...
            if (_this.editor && _this.editor.isDarkMode()) {
                // get whatever the current selection range is
                var selectionRange = _this.editor.getSelectionRange();
                if (selectionRange && !selectionRange.collapsed) {
                    var clipboardEvent = event;
                    var copyFragment = _this.editor.getSelectionRange().cloneContents();
                    var containerDiv = _this.editor.getDocument().createElement('div');
                    // Leverage script execution policy on CEDs to try and prevent XSS
                    containerDiv.contentEditable = 'true';
                    containerDiv.appendChild(copyFragment);
                    // revert just this selected range to light mode colors
                    normalizeContentColor_1.default(containerDiv);
                    // put it on the clipboard
                    clipboardEvent.clipboardData.setData('text/html', containerDiv.innerHTML);
                    clipboardEvent.clipboardData.setData('text/plain', containerDiv.innerText);
                    // if it's cut, delete the contents
                    if (isCut) {
                        _this.editor.getSelectionRange().deleteContents();
                    }
                    event.preventDefault();
                }
            }
        }; };
    }
    /**
     * Get a friendly name of  this plugin
     */
    CopyPlugin.prototype.getName = function () {
        return 'Copy';
    };
    /**
     * Initialize this plugin. This should only be called from Editor
     * @param editor Editor instance
     */
    CopyPlugin.prototype.initialize = function (editor) {
        this.editor = editor;
        this.eventDisposer = editor.addDomEventHandler({
            copy: this.onExtract(false),
            cut: this.onExtract(true),
        });
    };
    /**
     * Dispose this plugin
     */
    CopyPlugin.prototype.dispose = function () {
        this.eventDisposer();
        this.eventDisposer = null;
        this.editor = null;
    };
    return CopyPlugin;
}());
exports.default = CopyPlugin;
//# sourceMappingURL=CopyPlugin.js.map